import React from 'react';
import { ShowLeaderboardCard } from './cards/ShowLeaderboardCard';
import ShowDenseCard from './cards/ShowDenseCard';

const TrendingGrid = ({ shows, onOpen }) => {
  if (!shows || shows.length === 0) {
    return (
      <div className="empty" data-testid="trending-empty">
        <div className="empty-emoji" aria-hidden>🐑</div>
        <h2>The pasture is empty here</h2>
        <p>Baarry is lonely. Try the Global view to see what the wider flock is grazing on.</p>
        <style jsx>{`
          .empty {
            max-width: 480px;
            margin: 4rem auto;
            text-align: center;
            padding: 3rem 1.5rem;
            background: #131313;
            border: 1px dashed #2a2a2a;
            border-radius: 16px;
          }
          .empty-emoji {
            font-size: 3rem;
            margin-bottom: 1rem;
          }
          .empty h2 {
            color: #fff;
            font-size: 1.4rem;
            margin: 0 0 0.5rem;
          }
          .empty p {
            color: #a1a1aa;
            margin: 0;
          }
        `}</style>
      </div>
    );
  }

  const top = shows[0];
  const two = shows[1];
  const three = shows[2];
  const rest = shows.slice(3);

  return (
    <div className="trending-grid" data-testid="trending-grid">
      <div className="row-top">
        {top && (
          <div className="top-left">
            <ShowLeaderboardCard show={top} rank={1} onOpen={onOpen} />
          </div>
        )}
        {(two || three) && (
          <div className="top-right">
            {two && <ShowDenseCard show={two} rank={2} onOpen={onOpen} />}
            {three && <ShowDenseCard show={three} rank={3} onOpen={onOpen} />}
          </div>
        )}
      </div>

      {rest.length > 0 && (
        <>
          <div className="section-heading">
            <span className="bar" />
            <span>Also grazing</span>
          </div>
          <div className="row-dense">
            {rest.map((show, idx) => (
              <ShowDenseCard
                key={show.tmdb_id}
                show={show}
                rank={idx + 4}
                onOpen={onOpen}
              />
            ))}
          </div>
        </>
      )}

      <style jsx>{`
        .trending-grid {
          max-width: 1280px;
          margin: 3rem auto 0;
          padding: 0 1.5rem;
        }
        .row-top {
          display: grid;
          grid-template-columns: 1fr;
          gap: 1.25rem;
          margin-bottom: 3rem;
        }
        .top-right {
          display: grid;
          grid-template-rows: 1fr 1fr;
          gap: 1rem;
          align-content: start;
        }
        @media (min-width: 900px) {
          .row-top {
            grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);
            align-items: stretch;
          }
        }
        .section-heading {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin: 0 0 1.25rem;
          color: #a1a1aa;
          font-size: 0.72rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          font-weight: 800;
        }
        .bar {
          flex: 1;
          height: 1px;
          background: linear-gradient(90deg, transparent, #2a2a2a 60%, transparent);
        }
        .row-dense {
          display: grid;
          grid-template-columns: 1fr;
          gap: 0.85rem;
        }
        @media (min-width: 960px) {
          .row-dense {
            grid-template-columns: 1fr 1fr;
            gap: 1rem 1.25rem;
          }
        }
      `}</style>
    </div>
  );
};

export default TrendingGrid;
